import React from "react";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import { coin } from "src/assets";
import { s3baseUrl } from "src/config/config";
import GrAvatarGroup from "src/design-system/components/GrAvatarGroup";
import GrIcon from "src/design-system/components/GrIcon";
import icons from "src/design-system/icons";
import { gr, tokens } from "src/design-system/tokens";

// Counts row of a feed post (feed, dashboard, post popup / page): red heart + likers + "2 likes" on the
// left (opens the likes list); "1 comment" and coins + senders + "3 coins" (opens the coins list) on the
// right. Hidden when the post has no likes, comments or coins.
const AVATAR = tokens.icon.lg;

const rowSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: gr.space[3],
  minHeight: gr.icon.lg,
  fontFamily: gr.font.family,
  fontSize: gr.font.size.sm,
  lineHeight: gr.font.lineHeight.normal,
  color: gr.color.ink2,
};
const sideSx = { display: "flex", alignItems: "center", gap: gr.space[3] };
const countSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: gr.space[1],
  borderRadius: gr.radius.chip,
  font: "inherit",
  color: "inherit",
  "&:hover .count-label": {
    textDecoration: "underline",
    textUnderlineOffset: "3px",
  },
  "&.Mui-focusVisible": { boxShadow: gr.shadow.focus },
};
const heartSx = { display: "inline-flex", color: gr.color.danger };

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

export default function ActionsCount({
  handleOpenLikedBox,
  handleOpenCoinsBox,
  likeCount,
  coinsCount,
  commentCount,
  topLikedUser,
  topCoinedUser,
}) {
  if (!(likeCount > 0) && !(commentCount > 0) && !(coinsCount > 0)) return null;

  const likers = (topLikedUser || []).map((user) => ({
    id: user._id,
    name: user.name,
    src: s3baseUrl + user.profile_image,
  }));
  const senders = (topCoinedUser || []).map((point) => ({
    id: point._id,
    name: point.sender?.name,
    src: s3baseUrl + point.sender?.profile_image,
  }));

  return (
    <Box sx={rowSx} className="feed-counts">
      <Box sx={sideSx}>
        {likeCount > 0 && (
          <ButtonBase disableRipple sx={countSx} onClick={handleOpenLikedBox}>
            <Box component="span" sx={heartSx}>
              <GrIcon icon={icons.heartFilled} size="sm" />
            </Box>
            <GrAvatarGroup people={likers} size={AVATAR} max={2} />
            <span className="count-label">
              {plural(likeCount, "like", "likes")}
            </span>
          </ButtonBase>
        )}
      </Box>
      <Box sx={sideSx}>
        {commentCount > 0 && (
          <span>{plural(commentCount, "comment", "comments")}</span>
        )}
        {coinsCount > 0 && (
          <ButtonBase disableRipple sx={countSx} onClick={handleOpenCoinsBox}>
            <img
              src={coin}
              alt=""
              width={tokens.icon.sm}
              height={tokens.icon.sm}
            />
            <GrAvatarGroup people={senders} size={AVATAR} max={2} />
            <span className="count-label">
              {plural(coinsCount, "coin", "coins")}
            </span>
          </ButtonBase>
        )}
      </Box>
    </Box>
  );
}
